import { createSlice } from "@reduxjs/toolkit";

const {
  actions: {
    getPromoCodesStart,
    getPromoCodesSuccess,
    getPromoCodesFailure,
    getActivePromoCodesStart,
    getActivePromoCodesSuccess,
    getActivePromoCodesFailure,
    createPromoCodeStart,
    createPromoCodeFailure,
    createPromoCodeSuccess,
    updatePromoCodeStart,
    updatePromoCodeSuccess,
    updatePromoCodeFailure,
    updatePromoCodeOptimistic,
    deletePromoCodeStart,
    deletePromoCodeSuccess,
    deletePromoCodeFailure,
    sendUserPromoCodeStart,
    sendUserPromoCodeSuccess,
    sendUserPromoCodeFailure,
  },
  reducer,
} = createSlice({
  name: "promoCodes",
  initialState: {
    loading: false,
    promoCodes: null,
    activePromoCodes: [],
    activePromoCodesLoading: false,
    sendPromoLoading: false,
  },
  reducers: {
    getPromoCodesStart: (state) => ({
      ...state,
      loading: true,
    }),
    getPromoCodesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      promoCodes: payload,
    }),
    getPromoCodesFailure: (state) => ({
      ...state,
      loading: false,
    }),
    getActivePromoCodesStart: (state) => ({
      ...state,
      activePromoCodesLoading: true,
    }),
    getActivePromoCodesSuccess: (state, { payload }) => ({
      ...state,
      activePromoCodesLoading: false,
      activePromoCodes: payload,
    }),
    getActivePromoCodesFailure: (state) => ({
      ...state,
      activePromoCodesLoading: false,
    }),
    createPromoCodeStart: (state) => ({
      ...state,
      loading: true,
    }),
    createPromoCodeSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    createPromoCodeFailure: (state) => ({
      ...state,
      loading: false,
    }),
    updatePromoCodeStart: (state) => ({
      ...state,
    }),
    updatePromoCodeSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
    }),
    updatePromoCodeFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      promoCodes: state.promoCodes
        ? {
          ...state.promoCodes,
          data: state.promoCodes.data.map((code) =>
            code.promocodesId === payload.promocodesId
              ? { ...code, status: payload.previousStatus }
              : code
          ),
        }
        : null,
    }),
    updatePromoCodeOptimistic: (state, { payload }) => ({
      ...state,
      promoCodes: state.promoCodes
        ? {
          ...state.promoCodes,
          data: state.promoCodes.data.map((code) => {
            return code.promocodesId === payload.promocodesId
              ? { ...code, status: payload.newStatus }
              : code;
          }),
        }
        : null,
    }),
    deletePromoCodeStart: (state) => ({
      ...state,
      loading: true,
    }),
    deletePromoCodeSuccess: (state) => ({
      ...state,
      loading: false,
    }),
    deletePromoCodeFailure: (state) => ({
      ...state,
      loading: false,
    }),
    sendUserPromoCodeStart: (state) => ({
      ...state,
      sendPromoLoading: true,
    }),
    sendUserPromoCodeSuccess: (state) => ({
      ...state,
      sendPromoLoading: false,
    }),
    sendUserPromoCodeFailure: (state) => ({
      ...state,
      sendPromoLoading: false,
    }),
  },
});

export default reducer;

export {
  getPromoCodesStart,
  getPromoCodesSuccess,
  getPromoCodesFailure,
  getActivePromoCodesStart,
  getActivePromoCodesSuccess,
  getActivePromoCodesFailure,
  createPromoCodeStart,
  createPromoCodeFailure,
  createPromoCodeSuccess,
  updatePromoCodeStart,
  updatePromoCodeSuccess,
  updatePromoCodeFailure,
  updatePromoCodeOptimistic,
  deletePromoCodeStart,
  deletePromoCodeSuccess,
  deletePromoCodeFailure,
  sendUserPromoCodeStart,
  sendUserPromoCodeSuccess,
  sendUserPromoCodeFailure,
};
